import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import FlexContainer from 'components/FlexContainer';
import { FieldErrorMessage } from 'components/InputField/InputField.styled';
import {
  StyledCheckbox,
  StyledCheckmark,
  StyledError,
  StyledLabel,
} from './Checkbox.styled';
import ICheckbox from './types';

const Checkbox: React.FC<ICheckbox & { intl: IntlShape }> = ({
  label,
  checked,
  error,
  errorMessage,
  onChange,
  onEnter,
  disabled,
  intl: { formatMessage },
}) => (
  <FlexContainer flexDirection="column" width="100%">
    <StyledLabel>
      <StyledCheckbox
        checked={checked}
        disabled={disabled}
        error={error}
        onChange={onChange}
      />
      <StyledCheckmark
        role="checkbox"
        tabIndex={0}
        aria-label={formatMessage({
          id: 'message.paymentInitiation.termsAndConditions.checkboxName',
        })}
        aria-checked={checked ? 'true' : 'false'}
        onKeyDown={onEnter}
      />
      {label}
    </StyledLabel>
    {error ? (
      <StyledError>
        <FieldErrorMessage>
          <FormattedMessage id={errorMessage} />
        </FieldErrorMessage>
      </StyledError>
    ) : null}
  </FlexContainer>
);

export default injectIntl(Checkbox);
